import BaseAPI from './base.api.service'

const resource = 'report';
export default {
    async get(params) {
        return await BaseAPI.get(`ExpenseReports/${resource}${params}`);
    },
    async getMyReport(admin) {
        return await BaseAPI.get(`ExpenseReports/MyReport?isAdmin=${admin}&includeTotal=true&statusTypeIds=1&statusTypeIds=5&statusTypeIds=6`);
    },
    async getMyPaidReport() {
        return await BaseAPI.get(`ExpenseReports/MyReport?includeTotal=true&statusTypeIds=2&statusTypeIds=3&statusTypeIds=4&statusTypeIds=5&statusTypeIds=6&statusTypeIds=7&statusTypeIds=8`);
    },
    async getAnalysisReport(searchCrtieria) {
        return await BaseAPI.post(`ExpenseReports/Report/Analysis`, searchCrtieria);
    }
} 